<template>
  <svg viewBox="0 0 281.5 279.4">
    <path
      fill="#F79D19"
      d="M79 61.1c36.5-27.8 87.1-27.8 123.6 0l25.2-31C176.6-9.8 104.9-9.8 53.7 30L79 61.1z"
    />
    <path
      fill="#000"
      d="M235.6 36.6l-25.2 31.1c33.6 31.4 41.1 81.9 17.9 121.7l-55.5-53.3-25.9-58.3v88.6l54.9 52.8c-36.1 26.9-85.7 26.9-121.8 0l54.9-52.7V77.7l-26 58.3-55.5 53.3C30.2 149.6 37.6 99.1 71.2 67.7L45.9 36.6c-29.3 26.3-46 63.8-46 103.1 0 77 63.1 139.5 140.8 139.5 77.7 0 140.8-62.5 140.7-139.5.1-39.3-16.6-76.8-45.8-103.1zM271.2 217.6h1.4c.5 0 1.1 0 1.6.1.3 0 .6.2.8.4.4.4.7.9.6 1.5.1.9-.5 1.8-1.5 1.9l2 2.7h-1.8l-1.6-2.5v2.5h-1.5v-6.6zm1.4 1.2v1.7h.1c.3 0 .6 0 .9-.1.2-.2.4-.4.4-.7 0-.3-.1-.5-.3-.7-.3-.2-.6-.2-.9-.2h-.2zm.7 7.9c-3.2 0-5.8-2.6-5.8-5.8s2.6-5.8 5.8-5.8c3.2 0 5.8 2.6 5.8 5.8 0 3.3-2.6 5.8-5.8 5.8zm4.8-5.7c0-2.6-2.1-4.8-4.8-4.8-2.6 0-4.8 2.1-4.8 4.8 0 2.6 2.1 4.8 4.8 4.8 2.7-.1 4.8-2.2 4.8-4.8z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'OWIcon',
});
</script>

<style lang="scss" scoped>
svg {
  height: 2em;
  width: 2em;
}
</style>
